export const getSchemaOrgWebSite = ({ seo, defaultDocument }) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: seo.defaultTitle,
  url: `https://www.wooclap.com${defaultDocument.url}`,
});
